import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Column from '../../../core/layout/Column';
import FetchSelect from '../../../core/form/FetchSelect';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import { Roles } from '../../../core/util';

const GrammarListFilter = (props) => (
  <Row>
    {[Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) && (
      <Column size={4}>
        <FetchSelect
          url="distributors"
          label="Distributor"
          value={get(props.values, 'distributor', '')}
          onChange={(distributor) => {
            props.onChange('distributor', distributor);
            props.onSearch();
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
    )}
    <Column size={6}>
      <TextInput
        label="Search grammars by name"
        placeholder="Start type to filter the grammars"
        value={get(props.values, 'name', '')}
        onChange={(value) => {
          props.onChange('name', value);
          props.onSearch();
        }}
      />
    </Column>
  </Row>
);

GrammarListFilter.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default GrammarListFilter;
